<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.imageList && row.imageList.length > 0" :src="row.imageList[0].url" alt="图片" />
            <span v-if="row.imageList">*{{ row.imageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>



    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="WeddingImages">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="套餐名称" prop="name">
              <el-input v-model="currentCarData.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">

            <el-form-item label="套餐价格" prop="price">
              <el-input v-model="currentCarData.price" type="number" min="0"></el-input>
            </el-form-item>

          </el-col>


        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="服务时间" prop="serviceTime">
              <el-select v-model="currentCarData.serviceTime" placeholder="请选择">
                <el-option label="全天" value="1"></el-option>
                <el-option label="半天" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="跟妆师" prop="makeupArtist">
              <el-select v-model="currentCarData.makeupArtist" placeholder="请选择化妆师资历"
                @change="handleDialogSelectionChange2">
                <el-option v-for="item in categoriesMakeUpAritsTyps" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="造型数量" prop="mouldingNum">
              <el-select v-model="currentCarData.mouldingNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="妆面数量" prop="makeupNum">
              <el-select v-model="currentCarData.makeupNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附带助手" prop="assistantNum">
              <el-select v-model="currentCarData.assistantNum" placeholder="请选择">
                <el-option v-for="num in Array.from({ length: 6 }, (_, i) => i)" :key="num" :label="num"
                  :value="num"></el-option>
              </el-select>

            </el-form-item>
          </el-col>


        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="费用说明" prop="description">
              <el-input v-model="currentCarData.description"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="费用说明" prop="descriptionZh">
              <el-input v-model="currentCarData.descriptionZh"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col class="dialog-el" :span="24">
            <el-form-item label="赠送亲友妆">
              <el-checkbox-group v-model="checkList1">
                <el-checkbox v-for="item in categoriesMakeUp" :key="item.label" :label="item.label" :value="item.label">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>


        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArray = ref([]);
    const ruleFormRef = ref(null);
    const checkList1 = ref([]);
    const categoriesMakeUp = ref([]);
    const categoriesMakeUpAritsTyps = ref([]);
    const diaologTeamMakeupType = ref({});

    const dialogVisible = ref(false);



    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });


    // 表单验证规则
    const rules = reactive({
      WeddingImages: [
        {
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('请选择图片'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],
      name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      price: [{ required: true, message: '请输入价格', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      serviceTime: [{ required: true, message: '请选择服务时间', trigger: 'change' }],
      makeupArtist: [{ required: true, message: '请选择跟妆师', trigger: 'change' }],
      mouldingNum: [{ required: true, message: '请选择造型数量', trigger: 'change' }],
      makeupNum: [{ required: true, message: '请选择妆面数量', trigger: 'change' }],
      description: [{ required: true, message: '请输入维语费用说明', trigger: 'blur' }],
      descriptionZh: [{ required: true, message: '请输入中文费用说明', trigger: 'blur' }],

    });


    onMounted(() => {
      getCategoryData();
      getData();
    });

    const getCategoryData = async () => {
      try {
        const response = await get('adminCategories/getCategoriesByParentId/8')
        if (response.code === 200) {
          categoriesMakeUp.value = response.data[0];
          categoriesMakeUpAritsTyps.value = response.data[1];


        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const getData = async () => {
      try {
        const response = await get('adminWeddingMakeUp/allShopMakeUp', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {
      var giftMakeup = checkList1.value.join(',');

      const dataParam = {
        'price': currentCarData.value.price,
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'serviceTime': currentCarData.value.serviceTime,
        'makeupArtist': diaologTeamMakeupType.value ? diaologTeamMakeupType.value.id : '',
        'mouldingNum': currentCarData.value.mouldingNum,
        'makeupNum': currentCarData.value.makeupNum,
        'assistantNum': currentCarData.value.assistantNum,
        'giftMakeup': giftMakeup,
        'description': currentCarData.value.description,
        'descriptionZh': currentCarData.value.descriptionZh,
        'imagesId': currentCarData.value.imagesId,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };

      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminWeddingMakeUp/addMakeUp', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {

            imageArray.value.push(response.data);
            currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');



          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file);
      return false; // 阻止默认上传行为
    }

    const deleteMakeUpData = async (id) => {
      await get('adminCar/deleteCars/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (item) => {
      // 打印或处理编辑数据
      currentCarData.value = item;
      imageArray.value = item.imageList;

      if (item.giftMakeup != null) {
        checkList1.value = item.giftMakeup.split(',');
      }

      const obj2 = categoriesMakeUpAritsTyps.value.find(obj => obj.id === item.makeupArtist);
      diaologTeamMakeupType.value = obj2;

      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArray.value = [];
      checkList1.value = [];
      diaologTeamMakeupType.value = {};
      dialogFormVisible.value = true;


    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }

    const handleShowDeleteDialog = (row) => {
      currentCarData.value = row;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
       deleteMakeUpData(currentCarData.value.id);
    }

    const handleDialogSelectionChange2 = async (value) => {
      const obj = categoriesMakeUpAritsTyps.value.find(item => item.id === value);
      diaologTeamMakeupType.value = obj;
    }

    return {
      tableData,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      imageArray,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      beforeUpload,
      uploadFile,
      checkList1,
      categoriesMakeUp,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      categoriesMakeUpAritsTyps,
      handleDialogSelectionChange2,
      diaologTeamMakeupType,

    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
